
import Event = createjs.Event;

export class Poker2ChatEvent extends Event {
    public static ADD_MSG: string = "addmsg";
    public static ADD_LOG: string = "addlog";

    public playerId: number = 0;
    public userId: number = 0;
    public msg: string;
    public name: string;
    public isMod: boolean = false;
    public spec: boolean = false;

    constructor(type: string, playerId: number, userId: number, msg: string, name: string, isMod: boolean, spec: boolean, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.playerId = playerId;
        this.userId = userId;
        this.msg = msg;
        this.name = name;
        this.isMod = isMod;
        this.spec = spec;
    }
}
